import Vue from 'vue'
import Vuex from 'vuex'
import MenuStore from '../store/MenuStore'
import VehicleFormData from '@/store/VehicleFormData'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    MenuStore,
    VehicleFormData
  },
})
